import { BlockPickerOption } from '../BlockPickerPlugin/BlockPickerOption';
import { c } from 'ttag';
export function GetRemoteImageBlockOption(onSelect) {
    return new BlockPickerOption(c('B3.Notes.EditorToolbar.Action').t `Image from URL`, {
        iconName: 'image',
        keywords: ['image', 'url'],
        onSelect: onSelect,
    });
}
